module.exports = __webpack_public_path__ + "static/media/changeMind.b6685077.mp3";